import { Lock } from 'lucide-react'
import { LoginForm } from '@/components/auth/LoginForm'

export function LoginPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-brand-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo / branding */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-brand-500 text-white mb-4">
            <Lock size={28} />
          </div>
          <h1 className="text-heading-lg font-display text-text-primary">PPM Suite</h1>
          <p className="text-body-sm text-text-secondary mt-1">Project & Portfolio Management</p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-lg border border-border p-8">
          <h2 className="text-heading-md font-display text-text-primary mb-6">Sign in to your account</h2>
          <LoginForm />
        </div>

        <p className="text-center text-[11px] text-text-tertiary mt-6">
          Secured with Supabase Authentication
        </p>
      </div>
    </div>
  )
}
